import parsePhoneNumber from 'libphonenumber-js'

/**
 * Data shared by the email signature generator (app) and the signature
 * images rendered on the server (/api/signature-image), so both draw the same
 * texts.
 */
export const CLINIC = {
  addressLine1: '20-22 Mortimer Street',
  addressLine2: 'London W1T 3JW',
  email: 'clinic@thenoj.com',
  website: 'thenoj.com',
  websiteUrl: 'https://www.thenoj.com',
  instagramHandle: '@the-no.j',
  instagramUrl: 'https://instagram.com/the-no.j',
} as const

export const SIGNATURE_COLORS = ['wine', 'sage', 'lilac', 'black'] as const

export type SignatureColor = typeof SIGNATURE_COLORS[number]

export interface SignatureValues {
  fullname: string
  role: string
  email: string
  phone: string
  color: SignatureColor
}

export function signaturePhone(phone: string) {
  return phone ? parsePhoneNumber(phone, 'GB') : undefined
}

/**
 * Slices of the Outlook signature's text column, left to right, one per link:
 * see server/utils/signatureImage.ts.
 */
export type SignatureSlice = 'mail' | 'tel' | 'web'

export function signatureSlices(phone: string): SignatureSlice[] {
  return signaturePhone(phone) ? ['mail', 'tel', 'web'] : ['mail', 'web']
}

/**
 * Version of the signature images (/api/signature-image). Bump it whenever
 * their layout or rendering changes (server/utils/signatureImage.ts).
 *
 * It's part of the server cache key AND of the image URLs (`v=`): the PNGs are
 * served as immutable, so without a new URL browsers, the CDN and Gmail's image
 * proxy keep showing the old image, stretched to the new size in the HTML.
 */
export const SIGNATURE_IMAGE_VERSION = 21

/**
 * Background of the signature: drawn in the images (and the logo GIFs) and set
 * on the cells, which show between the lines once Gmail makes them taller.
 */
export const SIGNATURE_BACKGROUND = '#ffffff'
